<template>
  <section
    id="faq"
    class="co-bg-striped"
  >
    <div class="co-container-lg px-4 py-20">
      <h2 class="co-display-7 mb-[3.25rem] text-center">
        FAQ
      </h2>
      <div class="flex flex-col gap-x-8 md:flex-row">
        <!-- FAQ -->
        <div class="mb-14 basis-full md:basis-1/2">
          <div class="mb-4 flex items-baseline">
            <div class="basis-1/12">
              <p class="co-display-9 font-bold text-co-danger-500">
                Q
              </p>
            </div>
            <div class="basis-11/12">
              <h3 class="co-display-10 font-bold">
                全くの初心者ですが問題ありませんか？
              </h3>
            </div>
          </div>
          <div class="flex">
            <div class="basis-1/12">
              <p class="co-display-9 font-bold leading-normal text-co-info-500">
                A
              </p>
            </div>
            <div class="basis-11/12">
              <slot name="answer01">
                <p class="mb-4">
                  フロントエンドの基礎スキルがある方だけが受講できるコースです。初心者の方は、はじめての副業コースを先にご受講ください。
                </p>
                <p>
                  <a
                    href="/course/first-sidejob"
                    target="_blank"
                  >はじめての副業コースの詳細を見る</a>
                </p>
              </slot>
            </div>
          </div>
        </div>
        <!-- FAQ -->
        <div class="mb-14 basis-full md:basis-1/2">
          <div class="mb-4 flex items-baseline">
            <div class="basis-1/12">
              <p class="co-display-9 font-bold text-co-danger-500">
                Q
              </p>
            </div>
            <div class="basis-11/12">
              <h3 class="co-display-10 font-bold">
                参加に迷っているのですが…
              </h3>
            </div>
          </div>
          <div class="flex">
            <div class="basis-1/12">
              <p class="co-display-9 font-bold leading-normal text-co-info-500">
                A
              </p>
            </div>
            <div class="basis-11/12">
              <slot name="answer01">
                <p class="mb-4">
                  テックアカデミーへの参加を検討されている方向けに、無料でプロのカウンセラーに相談できる無料相談もご用意しています。お気軽にご参加ください。
                </p>
                <p>
                  <a
                    class="bot_open"
                    href="/counseling/htmlcss-schedule"
                  >無料相談の詳細はこちら</a>
                </p>
              </slot>
            </div>
          </div>
        </div>
      </div>
      <div class="flex flex-col gap-x-8 md:flex-row">
        <!-- FAQ -->
        <div class="mb-14 basis-full md:basis-1/2">
          <div class="mb-4 flex items-baseline">
            <div class="basis-1/12">
              <p class="co-display-9 font-bold text-co-danger-500">
                Q
              </p>
            </div>
            <div class="basis-11/12">
              <h3 class="co-display-10 font-bold">
                他のプログラミングスクールとの違いは？
              </h3>
            </div>
          </div>
          <div class="flex">
            <div class="basis-1/12">
              <p class="co-display-9 font-bold leading-normal text-co-info-500">
                A
              </p>
            </div>
            <div class="basis-11/12">
              <p>
                他のスクールは転職の支援が中心で副業のサポートに力を入れていません。テックアカデミーでは独自に獲得した案件を受講生に紹介することが可能です。また、案件は現役エンジニアのメンターと一緒に取り組むことができるので初心者でも安心です。
              </p>
            </div>
          </div>
        </div>
        <!-- FAQ -->
        <div class="mb-14 basis-full md:basis-1/2">
          <div class="mb-4 flex items-baseline">
            <div class="basis-1/12">
              <p class="co-display-9 font-bold text-co-danger-500">
                Q
              </p>
            </div>
            <div class="basis-11/12">
              <h3 class="co-display-10 font-bold">
                合計どのくらい学習時間が必要ですか？
              </h3>
            </div>
          </div>
          <div class="flex">
            <div class="basis-1/12">
              <p class="co-display-9 font-bold leading-normal text-co-info-500">
                A
              </p>
            </div>
            <div class="basis-11/12">
              <p>
                現在の理解度のレベルと進捗スピードによって異なりますが、目安として合計200時間ほどの確保をお願いしております。無駄を省いた学習システムと、メンターへの質問・課題レビューで通常より短期間で成長することが可能です。
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="flex flex-col gap-x-8 md:flex-row">
        <!-- FAQ -->
        <div class="mb-14 basis-full md:basis-1/2">
          <div class="mb-4 flex items-baseline">
            <div class="basis-1/12">
              <p class="co-display-9 font-bold text-co-danger-500">
                Q
              </p>
            </div>
            <div class="basis-11/12">
              <h3 class="co-display-10 font-bold">
                期間内に学習が終わらなかったらどうなりますか？
              </h3>
            </div>
          </div>
          <div class="flex">
            <div class="basis-1/12">
              <p class="co-display-9 font-bold leading-normal text-co-info-500">
                A
              </p>
            </div>
            <div class="basis-11/12">
              <p>
                受講期間終了後もカリキュラムは継続して閲覧が可能です。また、追加のメンターサポート（4週間：97,900円［税込］）もご利用いただけます。
              </p>
            </div>
          </div>
        </div>
        <!-- FAQ -->
        <div class="mb-14 basis-full md:basis-1/2">
          <div class="mb-4 flex items-baseline">
            <div class="basis-1/12">
              <p class="co-display-9 font-bold text-co-danger-500">
                Q
              </p>
            </div>
            <div class="basis-11/12">
              <h3 class="co-display-10 font-bold">
                地方からの参加は可能ですか？
              </h3>
            </div>
          </div>
          <div class="flex">
            <div class="basis-1/12">
              <p class="co-display-9 font-bold leading-normal text-co-info-500">
                A
              </p>
            </div>
            <div class="basis-11/12">
              <p>
                全てオンラインでの対応となっているため、国内、海外どこからでも参加が可能です。メンターが常時待機し、週2回のメンタリングもあるので、遠隔でもしっかりサポートが受けられます。
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="flex flex-col gap-x-8 md:flex-row">
        <!-- FAQ -->
        <div class="mb-14 basis-full md:basis-1/2">
          <div class="mb-4 flex items-baseline">
            <div class="basis-1/12">
              <p class="co-display-9 font-bold text-co-danger-500">
                Q
              </p>
            </div>
            <div class="basis-11/12">
              <h3 class="co-display-10 font-bold">
                受講終了後もカリキュラムは閲覧できますか？
              </h3>
            </div>
          </div>
          <div class="flex">
            <div class="basis-1/12">
              <p class="co-display-9 font-bold leading-normal text-co-info-500">
                A
              </p>
            </div>
            <div class="basis-11/12">
              <p>
                使用したカリキュラムは期間の制限なく継続してご覧いただけます。カリキュラムは都度アップデートしているため、最新情報で復習することが可能です。
              </p>
            </div>
          </div>
        </div>
        <!-- FAQ -->
        <div class="basis-full md:basis-1/2">
          <div class="mb-4 flex items-baseline">
            <div class="basis-1/12">
              <p class="co-display-9 font-bold text-co-danger-500">
                Q
              </p>
            </div>
            <div class="basis-11/12">
              <h3 class="co-display-10 font-bold">
                領収書や請求書の発行はできますか？
              </h3>
            </div>
          </div>
          <div class="flex">
            <div class="basis-1/12">
              <p class="co-display-9 font-bold leading-normal text-co-info-500">
                A
              </p>
            </div>
            <div class="basis-11/12">
              <p>
                可能です。領収書はお支払い後に発行方法をご案内します。また、法人からお申し込みの場合は請求書払いも対応しています。まずはご受講される方の名前でお申し込みいただき、指定のフォームからご申請ください。
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
